<template>

    <div v-if="!darkMode" class="container">

      <div class="monLogo">
        <router-link to="/">
          <img src="@/assets/home_blue.png" alt="logo Accueil" class="logo" />
        </router-link>
      </div>

        <h1>Mes compétences</h1>

        <div class="btns">
            <div class="btnLeft">
                <router-link to="/savoirsfaire">
                  <button>Savoirs-faire</button>
                </router-link>
            </div>

            <div class="btnRight">
                <router-link to="/savoirsEtre">
                <button>Savoirs-être</button>
                </router-link>
            </div>
        </div>
    </div>

    <div v-if="darkMode" class="container">

      <div class="monLogo">
        <router-link to="/">
          <img src="@/assets/home_white.png" alt="logo Accueil" class="logo" />
        </router-link>
      </div>

        <h1 class="h1Dark">Mes compétences</h1>

        <div class="btns">
            <div class="btnLeftDark">
              <router-link to="/savoirsfaire">
                  <button>Savoirs-faire</button>
                  </router-link>
              </div>

            <div class="btnRightDark">
              <router-link to="/savoirsEtre">
                  <button>Savoirs-être</button>
                </router-link>
            </div>
        </div>
    </div>


</template>

<script>
export default {

    computed: {
    darkMode(){
      return this.$store.state.darkMode
    }
  },


}
</script>

<style scoped>

*, ::before, ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.container{
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.monLogo{
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}

.monLogo img{
  width: 30px;
  height: auto;
}

h1{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #004080;
  color: transparent;
  margin-top: 30px;
}

.h1Dark{
  -webkit-text-stroke: 0.2px #fff;
}

.btns{
  display: flex;
  width: 60%;
  height: 300px;
  margin: 4rem auto;
  gap: 0.2rem;
}

.btnLeft{
  width: 50%;
  height: 100%;
  border: 1px solid grey;
  float: left;
  background: url('@/assets/whiteFond.jpg') no-repeat center center/cover;
  opacity: 0.5;
}

.btnLeft:hover{
  opacity: 1;
}

.btnLeft button{
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: transparent;
  font-size: 1.5rem;
  font-family: 'Quicksand', sans-serif;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  color: #004080;
}

.btnLeftDark{
  width: 50%;
  height: 100%;
  border: 1px solid grey;
  float: left;
  background: url('@/assets/blackSand.jpg') no-repeat center center/cover;
  opacity: 0.5;
}

.btnLeftDark:hover{
  opacity: 1;
}

.btnLeftDark button{
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: transparent;
  font-size: 1.5rem;
  font-family: 'Quicksand', sans-serif;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  color: #fff;
}

.btnRight{
  width: 50%;
  height: 100%;
  border: 1px solid grey;
  float: right;
  background: url('@/assets/whiteFond.jpg') no-repeat center center/cover;
  opacity: 0.5;
}

.btnRight:hover{
  opacity: 1;
}

.btnRight button{
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: transparent;
  font-size: 1.5rem;
  font-family: 'Quicksand', sans-serif;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  color: #004080;

}

.btnRightDark{
  width: 50%;
  height: 100%;
  border: 1px solid grey;
  float: right;
  background: url('@/assets/blackSand.jpg') no-repeat center center/cover;
  opacity: 0.5;
}

.btnRightDark:hover{
  opacity: 1;
}

.btnRightDark button{
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: transparent;
  font-size: 1.5rem;
  font-family: 'Quicksand', sans-serif;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  color: #fff;
}

</style>